import { render, staticRenderFns } from "./SmsConfirm.vue?vue&type=template&id=166b6f74&"
import script from "./SmsConfirm.vue?vue&type=script&lang=js&"
export * from "./SmsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SmsConfirm.vue?vue&type=style&index=0&id=166b6f74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports